import React from 'react';

/**
 * SSN Logo - Smart Short News
 * Icon: A rounded square containing three horizontal lines representing
 * "compressed / summarized news" - many sources reduced to a short summary.
 * A subtle blue dot on top-right represents the "smart" AI aspect.
 */
function Logo({ size = 32, showText = true, className = '' }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      {/* Icon mark */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
        aria-label="SSN Logo"
      >
        {/* Rounded background */}
        <rect
          x="2"
          y="2"
          width="36"
          height="36"
          rx="10"
          fill="url(#ssn-gradient)"
        />

        {/* Three stacked bars representing summarized news (short/long/medium) */}
        <rect x="10" y="13" width="20" height="3" rx="1.5" fill="white" fillOpacity="0.95" />
        <rect x="10" y="18.5" width="14" height="3" rx="1.5" fill="white" fillOpacity="0.85" />
        <rect x="10" y="24" width="17" height="3" rx="1.5" fill="white" fillOpacity="0.75" />

        {/* Small accent dot - the "smart" AI signal */}
        <circle cx="31" cy="9" r="2.5" fill="#22C55E" />
        <circle cx="31" cy="9" r="2.5" fill="#22C55E" opacity="0.4">
          <animate
            attributeName="r"
            values="2.5;5;2.5"
            dur="2.5s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="opacity"
            values="0.4;0;0.4"
            dur="2.5s"
            repeatCount="indefinite"
          />
        </circle>

        <defs>
          <linearGradient id="ssn-gradient" x1="2" y1="2" x2="38" y2="38" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#0055FF" />
            <stop offset="100%" stopColor="#0033AA" />
          </linearGradient>
        </defs>
      </svg>

      {/* Wordmark */}
      {showText && (
        <div className="flex flex-col leading-none">
          <span className="text-xl font-extrabold tracking-tight text-[#09090B] dark:text-[#FAFAFA]">
            SSN
          </span>
          <span className="text-[9px] font-semibold tracking-[0.15em] uppercase text-[#52525B] dark:text-[#A1A1AA] mt-0.5">
            Smart Short News
          </span>
        </div>
      )}
    </div>
  );
}

export default Logo;
